export function httpSafe(val: string) {
  if (location.protocol.indexOf("https") >= 0) {
    return (val + "").replace("http://", "https://");
  }
  return val;
}

// 动态域名下bfs图片地址转化处理
export function dynamicBFSUrl(url: string) {
  if (location.href.indexOf("bilibili") < 0) {
    const hostname = `${location.protocol}//${location.hostname}`;
    return url.replace(/^(http(s)?:)?\/\/i[0-2]\.hdslb\.com/, `${hostname}/bfs`);
  }
  return url.replace("http:", "https:");
}
